<template>
<div class="chapter">
<div class="inner_page">
<p class="part" id="part01"><a href="#/text/9780061753923_Contents#rpart01">Part One</a></p>
<p class="image1"><img alt="image" height="6" src="images/commona.jpg" width="146"/></p>
<p class="part1"><a href="#/text/9780061753923_Contents#rpart01">WEDDING<br/>VOWS</a></p>
<p class="part2"><a href="#/text/9780061753923_Contents#rpart01">August 18,1979<br/><br/>Oceanside, California</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061753923_Part_1.vue?1535e320